export function CenterLogo() {
  return (
    <img
      src="/banana.svg"
      alt="Logo"
      style={{ width: '100%', height: 'auto' }}
    />
  )
}
